import { render } from "./XIcon.vue?vue&type=template&id=1562306a&ts=true"
import script from "./XIcon.vue?vue&type=script&lang=ts"
export * from "./XIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__